// extracted by mini-css-extract-plugin
export var container = "shop-step-order-summary-module--container--j3sET";
export var green = "shop-step-order-summary-module--green--jPoFj";
export var large = "shop-step-order-summary-module--large--vViwU";
export var name = "shop-step-order-summary-module--name--D8GUQ";
export var priceRow = "shop-step-order-summary-module--price-row--t6p+D";
export var strike = "shop-step-order-summary-module--strike--AIxQA";
export var value = "shop-step-order-summary-module--value--Wem9j";